import { useMemo } from 'react';
import { AssetUtils } from '../services/asset/asset-api-service';
import { searchAssetsByName } from '../utils/SearchUtils';
import { sortAssetsByDistance } from '../utils/sortAssetsByDistance';

interface UserCoords {
    latitude: number;
    longitude: number;
}

export const useAssetSearch = (
    assets: any[],
    searchTerm: string,
    userCoords: UserCoords | null
) => {
    return useMemo(() => {
        let processedAssets = assets;

        // add distance first if we have coordinates
        if (userCoords) {
            processedAssets = sortAssetsByDistance(
                assets,
                userCoords,
                AssetUtils.formatAssetForDisplay
            );
        }

        // Then filter by search term if provided
        if (searchTerm.trim()) {
            processedAssets = searchAssetsByName(
                processedAssets, // Use assets with distance info
                searchTerm,
                AssetUtils.formatAssetForDisplay
            );
        }

        return processedAssets;
    }, [assets, searchTerm, userCoords]);
};